import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=08d8bb4a"
import script from "./order-item.vue?vue&type=script&lang=ts"
export * from "./order-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports